import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "nav-bar-menu-container" }
const _hoisted_2 = { class: "menu-text" }
const _hoisted_3 = { class: "dropdown-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["nav-bar-menu navbar-open-btn", { active: _ctx.dropdown }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.trigger && _ctx.trigger(...args)))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        class: "menu-icon",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        _createElementVNode("path", {
          d: "M4.49762 12H12.4976",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        _createElementVNode("path", {
          d: "M4.49762 16.0017H16.4976",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }),
        _createElementVNode("path", {
          d: "M4.49731 7.99832H19.4973",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('NavBar.menu')), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown", { active: _ctx.dropdown }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/faq",
          onClick: _ctx.close,
          class: "items-link navbar-support-btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('NavBar.support')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.userID)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/logout",
              class: "items-link navbar-signout-btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('NavBar.signout')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ])), [
    [_directive_click_outside, _ctx.close]
  ])
}